"use strict";
// if there is a ?discount in the query string, we'll save it in the session and set it on the window
// then, when the checkout url is generated, it will use the value set on the window variable
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeDiscountCookie = void 0;
var Cookies = __importStar(require("js-cookie"));
var whatwg_url_1 = require("whatwg-url");
var cookieName = 'discount';
var queryName = 'discount';
var query = new whatwg_url_1.URLSearchParams(window.location.search);
if (query.has(queryName)) {
    Cookies.set(cookieName, query.get(queryName));
}
var removeDiscountCookie = function () {
    Cookies.remove(cookieName);
};
exports.removeDiscountCookie = removeDiscountCookie;
window.discount = Cookies.get('discount');
